
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/link-wallet",
      function () {
        return require("private-next-pages/link-wallet.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/link-wallet"])
      });
    }
  